<template>
  <div
    id="email-stats"
  >
    <h2>{{ title }} Stats</h2>

    <newsletter-nav
      :newsletterId="newsletterId"
      v-if="newsletterId"
    />

    <email-nav
      :emailId="emailId"
      v-if="emailId"
    />

    <div
      class="list-group"
    >
      <router-link
        :to="{
          name: route,
          params: {
            emailId: emailId,
            newsletterId: newsletterId,
            status: name
          }
        }"
        v-for="count, name in stats"
        v-bind:key="name"
        :class="$root.listItemClasses"
      >
        {{ statusTitle(name) }} <span class="badge badge-light">{{ count }}</span>
      </router-link>
    </div>

  </div>
</template>

<script>
import EmailMixin from '@/mixins/EmailMixin'

import EmailNav from '@/components/EmailNav'
import NewsletterNav from '@/components/NewsletterNav'

import EmailRecipientStatusKey from '@/components/EmailRecipientStatusKey'

import { mapState } from 'vuex'

import humanize from 'humanize-string'
import titleize from 'titleize'

export default {
  computed: mapState({
    id () {
      return this.emailId || this.newsletterId
    },

    route () {
      return (
        this.newsletterId ? 'newsletter' : 'email'
      ) + '_stats_by_status'
    },

    title () {
      return titleize(humanize(this.modelType))
    },

    stats: state => state.EmailModule.stats
  }),

  components: {
    'email-nav': EmailNav,
    'newsletter-nav': NewsletterNav,
    'email-recipient-status-key': EmailRecipientStatusKey
  },

  mixins: [ EmailMixin, EmailRecipientStatusKey ],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.$store.dispatch(
        `EmailModule/getStats`, {
          emailId: this.id,
          emailType: this.modelType
        }
      ).catch(this.$root.processErrors)
    },

    statusTitle (name) {
      return titleize(humanize(name))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EmailStats.vue